import type * as React from "react";

import { cn } from "../lib/cn";

export type ChipTone = "recorded" | "brian" | "attention" | "declined";

export type ChipSize = "sm" | "md" | "lg";

// Kit-internal; not in the barrel.
export const toneFill: Record<ChipTone, string> = {
  recorded: "bg-fill-recorded",
  brian: "bg-fill-brian",
  attention: "bg-fill-attention",
  declined: "bg-fill-declined",
};

export const toneInk: Record<ChipTone, string> = {
  recorded: "border-ink-recorded",
  brian: "border-ink-brian",
  attention: "border-ink-attention",
  declined: "border-ink-declined",
};

const sizeType: Record<ChipSize, string> = {
  sm: "text-fine-print",
  md: "text-sm",
  lg: "text-[0.9375rem]",
};

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone: ChipTone;
  size?: ChipSize;
  icon?: React.ReactNode;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

export function Chip({
  tone,
  size = "lg",
  icon,
  children,
  className,
  ...rest
}: ChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-swipe blend-marker",
        "px-[9px] pt-[3px] pb-[4px] font-body font-medium leading-[1.2] text-ink",
        toneFill[tone],
        sizeType[size],
        className,
      )}
      {...rest}
    >
      {icon != null && (
        <span aria-hidden="true" className="mr-[0.35em] inline-flex shrink-0">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
